export function getRolesList(roles) {
	let list = "<ul class='webix_um_roleslist'>";
	roles.forEach(role => {
		if (role.direct)
			list +=
				"<li class='webix_um_roleslist_item webix_um_roleslist_item_direct'>";
		else {
			list += `<li class='webix_um_roleslist_item' data-id='${role.id}'>`;
			list += `<span class='webix_um_roleslist_item_marker webix_icon umi-roles' style='color: ${
				role.color ? role.color : ""
			}'></span>`;
		}

		list += role.name + "</li>";
	});
	list += "</ul>";
	return list;
}
